module.exports = __webpack_public_path__ + "img/Group 26847New.393f2d87.png";